export function SAVE_FILTERS(state, [search, selected_areas, selected_tags]){
    state.search = search
    state.selected_areas = selected_areas
    state.selected_tags = selected_tags
}